import cloudicon from "./cloudicon.svg";

export default function CloudIcon() {
  return (
    <img src={cloudicon} />
  );
}